import { createSelector, createFeatureSelector } from '@ngrx/store';
import { OnDemandState, contentTypeAdapter, folderAdapter, videoAdapter } from './on-demand.state';

const selectOnDemandState = createFeatureSelector<OnDemandState>('onDemand');

const {
  selectAll: selectAllContentTypes,
  selectEntities: selectContentTypeEntities,
  selectTotal,
} = contentTypeAdapter.getSelectors();
const { selectAll: selectAllFolders, selectEntities: selectFolderEntities } = folderAdapter.getSelectors();

const { selectAll: selectAllVideos, selectEntities: selectVideoEntities } = videoAdapter.getSelectors();

export const selectContentTypeState = createSelector(selectOnDemandState, state => state.contentTypes);
export const selectFolderState = createSelector(selectOnDemandState, state => state.folders);
export const selectVideoState = createSelector(selectOnDemandState, state => state.videos);

export const selectAllContentTypesArray = createSelector(selectContentTypeState, selectAllContentTypes);
export const selectContentTypeEntitiesMap = createSelector(selectContentTypeState, selectContentTypeEntities);

export const selectAllFoldersArray = createSelector(selectFolderState, selectAllFolders);
export const selectFolderEntitiesMap = createSelector(selectFolderState, selectFolderEntities);

export const selectAllVideoArray = createSelector(selectVideoState, selectAllVideos);
export const selectVideoEntitiesMap = createSelector(selectVideoState, selectVideoEntities);

export const selectContentTypeById = (id: string) =>
  createSelector(selectContentTypeEntitiesMap, entities => entities[id]);
export const selectFolderById = (id: string) => createSelector(selectFolderEntitiesMap, entities => entities[id]);
export const selectVideoById = (id: string) => createSelector(selectVideoEntitiesMap, entities => entities[id]);

export const selectContentTypeIdsArray = createSelector(selectContentTypeEntitiesMap, entities =>
  Object.keys(entities)
);
export const selectFolderIdsArray = createSelector(selectFolderEntitiesMap, entities => Object.keys(entities));
export const selectVideoIdsArray = createSelector(selectVideoEntitiesMap, entities => Object.keys(entities));

export const selectTotalContentTypes = createSelector(selectContentTypeState, selectTotal);

export const selectContentTypesPagination = createSelector(selectOnDemandState, (state: OnDemandState) => {
  return {
    totalPages: state.contentTypesTotalPages ?? 0,
    currPage: state.contentTypesCurrPage ?? 0,
    totalItems: state.contentTypesTotalItems ?? 0,
  };
});

export const selectFoldersPagination = createSelector(selectOnDemandState, (state: OnDemandState) => {
  return {
    totalPages: state.folderTotalPages ?? 0,
    currentPage: state.folderCurrPage ?? 0,
    totalItems: state.folderTotalItems ?? 0,
  };
});

export const selectVideosPagination = createSelector(selectOnDemandState, (state: OnDemandState) => {
  return {
    totalPages: state.videoTotalPages ?? 0,
    currentPage: state.videoCurrPage ?? 0,
    totalItems: state.videoTotalItems ?? 0,
  };
});

export const selectSlider = createSelector(selectOnDemandState, (state: OnDemandState) => {
  return {
    isShowAll: state.isShowAll,
    sliderRange: state.sliderRange,
  };
});

export const selectLoadingVideos = createSelector(selectOnDemandState, (state: OnDemandState) => state.loadingVideos);

export const selectAccess = createSelector(selectOnDemandState, (state: OnDemandState) => state.accessFolder);
